import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdminState } from '../reducers/admin.reducer';
import { ADMIN_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<AdminState>(ADMIN_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: AdminState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: AdminState) => state.loading);
export const selectSaving = createSelector(selectState, (state: AdminState) => state.saving);
export const selectSaved = createSelector(selectState, (state: AdminState) => state.saved);
export const selectError = createSelector(selectState, (state: AdminState) => state.error);
export const selectAdmin = createSelector(selectState, (state: AdminState) => state.admin);
